import React, { useContext } from 'react';
import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { AppContext } from 'views/App/context';
import QuickAction from 'components/_atoms/QuickAction';
import { ArrowOutward, BarChart, InsertDriveFileOutlined, IosShare, ModelTrainingOutlined } from '@mui/icons-material';

export default function PolicySolutions() {
  const { currentOrganizationId, hasAppPermission, hasPermission } = useContext(AppContext);

  return (
    <Card className='policy-solutions lex-dashboard-card'>
      <CardHeader title={t('dashboard.policy.policySolutions.title')} />
      <CardContent>
        <Card>
          <CardContent>
            <Stack spacing={2}>
              {hasPermission('reportUserList', currentOrganizationId) && (
                <QuickAction
                  id='report'
                  title={t('dashboard.policy.policySolutions.report.title')}
                  subtitle={t('dashboard.policy.policySolutions.report.subtitle')}
                  href='/admin/reporting'
                  startIcon={<BarChart />}
                  endIcon={<ArrowOutward />}
                />
              )}
              {hasAppPermission('listDraftManuals') && (
                <QuickAction
                  id='policies'
                  title={t('dashboard.policy.policySolutions.policies.title')}
                  subtitle={t('dashboard.policy.policySolutions.policies.subtitle')}
                  href='/admin/policy/draft-manuals'
                  startIcon={<InsertDriveFileOutlined />}
                  endIcon={<ArrowOutward />}
                />
              )}
              {hasAppPermission('listIssuedManuals') && (
                <QuickAction
                  id='share'
                  title={t('dashboard.policy.policySolutions.share.title')}
                  subtitle={t('dashboard.policy.policySolutions.share.subtitle')}
                  href='/admin/policy/issued-manuals'
                  startIcon={<IosShare />}
                  endIcon={<ArrowOutward />}
                />
              )}
              {hasPermission('assignDtbPackageToGroup', currentOrganizationId) && (
                <QuickAction
                  id='assignTraining'
                  title={t('dashboard.policy.policySolutions.assignTraining.title')}
                  subtitle={t('dashboard.policy.policySolutions.assignTraining.subtitle')}
                  href='/admin/dtbs/assignments'
                  startIcon={<ModelTrainingOutlined />}
                  endIcon={<ArrowOutward />}
                />
              )}
            </Stack>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  );
}
